import { getCookie } from './cookies';

/**
 * API calls related to authentication.
 * This is separated from AuthContext to avoid circular dependencies with fetchWithAuth.
 */

/**
 * Calls the backend endpoint to refresh the authentication token.
 * This function also updates the csrf_token cookie upon success.
 * @returns {Promise<boolean>} - True if the token was refreshed successfully, false otherwise.
 */
export async function refreshTokenApi() {
  try {
    const response = await fetch('/api/auth/refresh', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCookie('csrf_token') || '',
      },
    });

    if (response.ok) {
      const data = await response.json();
      if (data.success) {
        // Update CSRF token in cookie for subsequent requests
        document.cookie = `csrf_token=${data.csrf_token}; path=/; max-age=3600; samesite=strict`;
        console.log('Token refreshed successfully via refreshTokenApi');
        return true;
      }
    }
    
    const errorText = await response.text();
    console.error('Failed to refresh token:', response.status, errorText);
    return false;
  } catch (error) {
    console.error('Error refreshing token:', error);
    return false;
  }
}
